import * as Phaser from "phaser-ce"
import { COLOR } from "../../../common/Color"
import { Buttons } from "../../generic-sprites/Buttons"
import { GenericAssets } from "../../generic-sprites/GenericAssets"
import { RadioGroup, RadioOption } from "../../generic-sprites/RadioButtons"
import { PhaserText } from "../../utils/PhaserText"
import { Scale } from "../../utils/Scale"
import { EcigTourAssets } from "./ecig-tour/EcigTourAssets"

export class ReviewQuestion {
    private onCorrect: () => void
    private index: number
    private currentAudio: Phaser.Sound
    private radioGroup: RadioGroup

    constructor(
        private game: Phaser.Game,
        private question: string,
        private answers: Array<string>,
        private correctIndex: number,
        private encouragementAudio: string,
        private questionAudio: string,
        private answersAudio: Array<string>,
        private isAllOfTheAbove: boolean = false,
    ) {}

    /**
     * You still need to call "Ask Question" on question 1 after calling this.
     *
     * @param {ReviewQuestion[]} questions
     * @param {() => void} finalOnComplete
     */
    static askQuestions = (
        questions: Array<ReviewQuestion>,
        finalOnComplete: () => void,
    ) => {
        for (let x = 0; x < questions.length; x++) {
            const question = questions[x]
            question.index = x
            if (questions.length - 1 === x) {
                question.onCorrect = finalOnComplete
            } else {
                question.onCorrect = () => {
                    questions[x + 1].displayQuestionAndAskQuestion()
                }
            }
        }
        questions[0].displayQuestion()
        questions[0].playQuestionAudio()
    }

    displayQuestionAndAskQuestion = () => {
        this.displayQuestion()
        this.playQuestionAudio()
    }

    displayQuestion = () => {
        let startX = Scale.width() * 0.2
        const startY = Scale.height() * 0.3

        const allText = this.game.add.group()

        const questionNumberSprite = PhaserText.create(
            this.game,
            (this.index + 1).toString() + ")",
            { x: startX, y: startY, color: COLOR.white, group: allText },
        )

        startX += questionNumberSprite.width + Scale.width() * 0.02

        const questionSprite = PhaserText.create(this.game, this.question, {
            x: startX,
            y: startY,
            color: COLOR.white,
            group: allText,
            wordWrapWidth: 0.55,
        })

        const questionY =
            questionSprite.y + questionSprite.height + Scale.height() * 0.05

        const radioOptions = this.answers.map(
            (text, i): RadioOption => ({
                text,
                audioKey: this.answersAudio[i],
                color: COLOR.white,
            }),
        )

        this.radioGroup = new RadioGroup(
            this.game,
            startX,
            questionY,
            radioOptions,
            () => {
                submitButton.enable(this.radioGroup.currentlySelected != null)
                // selection performed
            },
            false,
            false,
            22,
            allText,
        )
        let unansweredQuestions = this.radioGroup.buttons

        const handleAnswer = () => {
            unansweredQuestions.map((button) => button.disable(COLOR.white))
            submitButton.disable()

            const selected = this.radioGroup.buttons[
                this.radioGroup.currentlySelectedIndex
            ]
            if (this.radioGroup.currentlySelectedIndex === this.correctIndex) {
                const happyBell = this.game.add.audio(GenericAssets.BELL_SOUND)
                const bellTimer = this.game.time.create()
                bellTimer.add(1000, () => {
                    happyBell.stop()
                    const encouragement = this.game.add.audio(
                        this.encouragementAudio,
                    )
                    encouragement.onStop.addOnce(() => {
                        allText.destroy()
                        unansweredQuestions = []
                        this.onCorrect()
                    })
                    encouragement.play()
                })
                bellTimer.start()
                happyBell.play()
                if (this.isAllOfTheAbove) {
                    this.radioGroup.disable(COLOR.white)
                }
                selected.disable(COLOR.green)
            } else {
                const buzzer = this.game.add.audio(EcigTourAssets.BUZZ)
                buzzer.onStop.add(() => {
                    const tryAgain = this.game.add.audio(
                        EcigTourAssets.TRY_AGAIN,
                    )
                    tryAgain.onStop.add(() => {
                        unansweredQuestions.map((button) => button.enable())
                    })
                    tryAgain.play()
                })
                buzzer.play()
                selected.disable(COLOR.red)
                unansweredQuestions = unansweredQuestions.filter(
                    (answered) => answered !== selected,
                )
            }
        }
        const submitButton = Buttons.create(this.game, "Submit", handleAnswer, {
            x: startX,
            y:
                this.radioGroup.group.top +
                this.radioGroup.group.height +
                Scale.y(0.02),
            group: allText,
        })
        submitButton.disable()
    }

    playQuestionAudio = () => {
        this.currentAudio = this.game.add.audio(this.questionAudio)
        this.currentAudio.onStop.addOnce(() => {
            this.radioGroup.enable()
        })
        this.currentAudio.play()
    }
}
